import VueLib from 'vue'
import * as Sentry from '@sentry/browser'

import { Dedupe, ExtraErrorData, RewriteFrames, Vue } from '@sentry/integrations'

export default function (ctx, inject) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {"dsn":"https:\u002F\u002F64ba7193efb847a9abe6b45b2fb8f88d@o269273.ingest.sentry.io\u002F5468171","environment":"Production","tracesSampleRate":0.1,"release":"frontend-public@2.13.8","beforeSend":function(event, hint) {
        const exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value === 'Non-Error promise rejection captured with keys: currentTarget, detail, isTrusted, target') {
          return null;
        }
        if (window.navigator.userAgent.includes('Bytespider')) {return null;}
        if (hint.originalException === 'Timeout') {return null;}
        return event;
      }}
  config.integrations = [
    new Dedupe({}),
    new ExtraErrorData({}),
    new RewriteFrames({}),
    new Vue({ Vue: VueLib, ...{"attachProps":true,"logErrors":false,"tracing":true,"tracingOptions":{"trackComponents":true}}})
  ]

  /* eslint-enable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  Sentry.init(config)

  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
